<div class="position-relative">
  <div *ngIf="loading"
    class="position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center rounded-3 bg-white bg-opacity-75"
    style="z-index: 2; min-height: 120px;">
    <div class="spinner-border text-primary" role="status">
      <span class="visually-hidden">{{ 'loading' | translate }}</span>
    </div>
  </div>
  <div>{{ 'programs' | translate }}: {{ schedules.length }} / {{ getMaxPrograms() }}</div>

<div *ngIf="schedules.length === 0 "
  class="border border-2 border-dashed rounded-3 bg-light bg-opacity-25 d-flex align-items-center justify-content-center py-5">
  <div class="text-center text-muted px-4">
    <i class="fas fa-calendar-days fa-2x mb-3 opacity-50"></i>
    <p class="mb-0 small fw-semibold">{{ 'weeklySchedule' | translate }}</p>
    <p class="mb-0 small opacity-75">{{ 'programsAddHint' | translate }}</p>
  </div>
</div>

<div *ngIf="schedules.length > 0" class="table-responsive">
  <table class="table table-sm table-striped align-middle mb-0">
    <thead>
      <tr>
        <!-- <th class="text-nowrap">#</th> -->
        <th class="text-nowrap">{{ 'name' | translate }}</th>
        <!-- <th class="text-nowrap">{{ 'lumPriority' | translate }}</th> -->
        <th class="text-nowrap">{{ 'holidayStart' | translate }}</th>
        <!-- <th class="text-nowrap">{{ 'holidayEnd' | translate }}</th> -->
        <th class="text-nowrap">{{ 'se repite'}}</th>
        <th class="text-nowrap">{{ 'periods' | translate }}</th>
        <th class="text-nowrap text-center">{{ 'enabled' | translate }}</th>
        <th class="text-nowrap">{{ 'Acciones'}}</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let schedule of schedules; let i = index">
        <!-- <td class="text-nowrap">{{ schedule.id ?? (i + 1) }}</td> -->
        <td class="text-nowrap">{{ schedule.cfg?.name || '--' }}</td>
        <!-- <td class="text-nowrap">{{ schedule.cfg?.priority ?? '--' }}</td> -->

        <!-- INICIO -->
        <td class="text-nowrap">
          <div class="d-flex align-items-center gap-2">
            <i
              [class]="getIconStart(schedule.cfg?.time_cfg?.start?.type) + ' text-muted m-0'"
              [title]="schedule.cfg?.time_cfg?.start?.type">
            </i>
            <span *ngIf="schedule.cfg?.time_cfg?.start?.type === 'ocaso'">
              {{ astcalData?.cfg?.sunset_corr ===0 ? getTimeAstcalData(astcalData?.stat?.sunset) : getTimeAstcalData(astcalData?.stat?.sunset_with_correction) }}
            </span>
            <span *ngIf="schedule.cfg?.time_cfg?.start?.type === 'orto'">
              {{ astcalData?.cfg?.sunrise_corr ===0 ? getTimeAstcalData(astcalData?.stat?.sunrise) : getTimeAstcalData(astcalData?.stat?.sunrise_with_correction) }}
            </span>
            <span *ngIf="schedule.cfg?.time_cfg?.start?.type === 'fixed'">
              {{ getTimeFixedData(schedule.cfg?.time_cfg?.start?.offset_sec) }}
            </span>
            <svg viewBox="0 0 24 24" width="24" height="24" class="text-secondary flex-shrink-0"
              [attr.title]="((schedule.cfg?.actions?.[0]?.start_action || '').toLowerCase() === 'on' ? 'on' : 'off') | translate"
              [attr.aria-label]="((schedule.cfg?.actions?.[0]?.start_action || '').toLowerCase() === 'on' ? 'on' : 'off') | translate">
              <path
                [attr.d]="getRelaySwitchPath(schedule.cfg?.actions?.[0]?.start_action)"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
              />
            </svg>
          </div>
        </td>

        <!-- FIN -->
        <!-- <td class="text-nowrap">
          <div class="d-flex align-items-center gap-2">
            <i
              [class]="getIconEnd(schedule.cfg?.mode, schedule.cfg?.time_cfg?.end?.type) + ' text-muted m-0'"
              [title]="schedule.cfg?.time_cfg?.end?.type">
            </i>
            <span *ngIf="schedule.cfg?.time_cfg?.end?.type === 'ocaso'">
              {{ getTimeAstcalData(astcalData.stat?.sunset) }}
            </span>
            <span *ngIf="schedule.cfg?.time_cfg?.end?.type === 'orto'">
              {{ getTimeAstcalData(astcalData.stat?.sunrise) }}
            </span>
            <span *ngIf="schedule.cfg?.time_cfg?.end?.type === 'fixed' && (schedule.cfg?.mode === 'auto' || schedule.cfg?.mode === 'cyclic')">
              {{ getTimeFixedData(schedule.cfg.time_cfg.end.offset_sec) }}
            </span>
            <span *ngIf="schedule.cfg?.mode === 'timed'">
              {{ getTimeFixedData(schedule.cfg.time_cfg.duration_sec) }}
            </span>
            <svg viewBox="0 0 24 24" width="24" height="24" class="text-secondary flex-shrink-0"
              [attr.title]="((schedule.cfg?.actions?.[0]?.stop_action || '').toLowerCase() === 'on' ? 'on' : 'off') | translate"
              [attr.aria-label]="((schedule.cfg?.actions?.[0]?.stop_action || '').toLowerCase() === 'on' ? 'on' : 'off') | translate">
              <path
                [attr.d]="getRelaySwitchPath(schedule.cfg?.actions?.[0]?.stop_action)"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
              />
            </svg>
          </div>
        </td> -->
        <td>
          <div class="d-flex align-items-center flex-wrap gap-1">
            <span *ngFor="let day of daysOfWeek"
              class="badge rounded-pill d-inline-flex align-items-center justify-content-center"
              style="width: 20px; height: 20px; font-size: 0.65rem;"
              [ngClass]="isWeekdaySelected(schedule, day.value) ? 'bg-primary text-white' : 'bg-secondary bg-opacity-10 text-muted'"
              [attr.title]="day.key | translate">
              {{ day.short }}
            </span>
          </div>
        </td>

        <td>{{ !schedule.cfg?.time_cfg?.calendar?.period_ids?.length ? '--' : getPeriodIds(schedule.cfg?.time_cfg?.calendar?.period_ids) }}</td>


        <td class="text-center">
          <label class="switch-sm mb-0 align-middle">
            <input
              type="checkbox"
              [id]="'lumScheduleEnabled-' + schedule.id"
              [name]="'lumScheduleEnabled-' + schedule.id"
              [checked]="schedule.cfg.enabled"
              [attr.aria-label]="'enabled' | translate"
              (change)="toggleScheduleEnabled(schedule, $event)">
            <span class="slider round"></span>
          </label>
        </td>
        <td>
          <div class="d-flex align-items-center gap-2">
            <button type="button" class="btn btn-sm btn-link p-0 text-primary fs-6"
              [disabled]="loading"
              (click)="openScheduleModal(schedule)"
              [attr.aria-label]="'editSchedule' | translate"
              [title]="'edit' | translate">
              <i class="fas fa-edit"></i>
            </button>
            <button type="button" class="btn btn-sm btn-link p-0 text-danger fs-6"
              [disabled]="loading"
              (click)="deleteSchedule(schedule)"
              [attr.aria-label]="'deleteScheduleAria' | translate"
              [title]="'delete' | translate">
              <i class="fa-solid fa-trash"></i>
            </button>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</div>

<div class="d-flex flex-wrap justify-content-end align-items-center gap-2 mt-3">
  <button type="button" class="btn btn-primary" (click)="openScheduleModal()" [disabled]="loading || schedules.length >= getMaxPrograms()"
    [attr.aria-label]="'newProgramTitle' | translate" [title]="'newProgramTitle' | translate">
    <i class="fas fa-plus"></i>
  </button>
</div>
</div>
